import styled, { createGlobalStyle } from 'styled-components';
import { color, container, screen, spacing } from 'theme';

export const GlobalStyles = createGlobalStyle`
  :root {
    --out-of-office-blue: #0B50B5;
    --out-of-office-yellow: #FFD514;
  }
`;

export const StyledPage = styled.main`
  background-color: ${color('sand_100')};
  color: ${color('navy_700')};
  min-height: 100vh;

  > img {
    width: 100%;
    @media (max-width: ${screen('mdMax')}) {
      &.desktop {
        display: none;
      }
    }
    @media (min-width: ${screen('md')}) {
      &.mobile {
        display: none;
      }
    }
  }
`;

export const StyledContainer = styled.div`
  max-width: ${container('lg')};
  padding-left: ${spacing('md')};
  padding-right: ${spacing('md')};
  margin: auto;
  min-height: 100vh;
`;
